import axios from 'axios'
import Constants from '../constants'

export default {
  getLocation: () => {
    return new Promise((resolve) => {
      axios.get('location', { params: { id: Constants.API_ID } })
        .then(payload => {
          resolve(payload.data)
        })
    })
  }
}
